import React, { useState, useEffect, useMemo } from 'react';
import {
	Button,
	Col,
	Input,
	Row,
	Label,
	ModalBody,
	Form,
	TabPane,
	TabContent,
	Spinner,
	FormFeedback,
	FormGroup,
	Table,
} from 'reactstrap';

// Formik
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';

//redux
import { addNewEstablishment, updateEstablishment } from '../../../../slices/establishment/thunk';
import { setRequireCloseModal } from '../../../../slices/establishment/reducer';
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import { getCommuneList, getCompanyList, getManagementList, getEstablishmentTypeList, getProductiveAreaList, getSanitaryVicinityList, getRegionList, getEstablishmentStatusList, getPropertyTypeList, getEstablishmentList, getCostCenterList } from '../../../../helpers/establishment/backend_helper';
import OSelect from '../../../../Components/OElements/OSelect';
import { getDataSpedListNMBahia, getDataSpedListNMCapitania } from '../../../../helpers/data_sped/backend_helper';
import { getWarehouseGroupList, getWarehouseList } from '../../../../helpers/warehouse/backend_helper';
// import { getWarehouseGroupList } from '../../../../slices/thunks';
import SimpleBar from 'simplebar-react';
import { ODataGrid } from '../../../../Components/OElements/ODataGrid';

import OInput from '../../../../Components/OElements/OInput';
import { Link } from 'react-router-dom';
const EstablishmentForm = ({
	dataEstablishment,
	isEdit,
	handleToggleModal,
	isOpen,
	activeTab,
	toggleTab,
}) => {
	const dispatch = useDispatch();

	const [selectedVisibility, setselectedVisibility] = useState(null);
	const [sanitaryVicinityCol, setSanitaryVicinityCol] = useState(false);

	function handleSelectVisibility(selectedVisibility) {
		setselectedVisibility(selectedVisibility);
	}

	const [selectedEstablishmentType, setSelectedEstablishmentType] = useState(null);
	const handleEstablishmentTypeSelect = (optionSelected) => {
		setSelectedEstablishmentType(optionSelected);
		if (optionSelected) {
			const code = optionSelected.code
			if (code !== "SWE" && code !== "LWE") {
				setSanitaryVicinityCol(true)
			}
		}
		else {
			setSanitaryVicinityCol(false)
		}
	};

	const [selectedCostCenter, setSelectedCostCenter] = useState(null);
	const handleCostCenterSelect = (optionSelected) => {
		setSelectedCostCenter(optionSelected);
	};

	const [selectedCompany, setSelectedCompany] = useState(null);
	const handleCompanySelect = (optionSelected) => {
		setSelectedCompany(optionSelected);
	};

	const [selectedCommune, setSelectedCommune] = useState(null);
	const handleCommuneSelect = (optionSelected) => {
		setSelectedCommune(optionSelected);
	};

	const [selectedRegion, setSelectedRegion] = useState(null);
	const handleRegionSelect = (optionSelected) => {
		setSelectedRegion(optionSelected);
	};

	const [selectedSanitaryVicinity, setSelectedSanitaryVicinity] = useState(null);
	const handleSanitaryVicinitySelect = (optionSelected) => {
		setSelectedSanitaryVicinity(optionSelected);
	};

	const [selectedProductiveArea, setSelectedProductiveArea] = useState(null);
	const handleProductiveArea = (optionSelected) => {
		setSelectedProductiveArea(optionSelected);
	};

	const [selectedNMCapitania, setSelectedNMCapitania] = useState(null);
	const handleNMCapitania = (optionSelected) => {
		setSelectedNMCapitania(optionSelected ? optionSelected : []);
	};

	const [selectedNMBahia, setSelectedNMBahia] = useState([]);



	const [selectedWarehouse, setSelectedWarehouse] = useState(null);
	const handleWarehouse = (optionSelected) => {
		setSelectedWarehouse(optionSelected);
	};

	const [selectedWarehouseGroup, setSelectedWarehouseGroup] = useState(null);
	const handleWarehouseGroup = (optionSelected) => {
		setSelectedWarehouseGroup(optionSelected);
	};

	const [selectedEstablishmentGroup, setSelectedEstablishmentGroup] = useState(null);
	const handleEstablishmentGroup = (optionSelected) => {
		setSelectedEstablishmentGroup(optionSelected);
	};

	const [selectedManagement, setSelectedManagement] = useState(null);
	const [managementKey, setManagementKey] = useState(Date.now()); // Para forzar la recarga del OSelect
	const handleManagementSelect = (optionSelected) => {
		setSelectedManagement(optionSelected);
		// validation.setFieldValue('management_id', optionSelected?.management_id || '');
	};


	const [dataGroupList, setDataGroupList] = useState([]);
	const [selectedWarehouseItems, setSelectedWarehouseItemsState] = useState(dataEstablishment?.warehouse_group || []);
	const [selectedEstablishmentItems, setSelectedEstablishmentItemsState] = useState(dataEstablishment?.establishment_group || []);


	const [showMsg, setShowMsg] = useState(true);
	const [showMsgSelected, setShowMsgSelected] = useState(true);
	const [showMsgError, setShowMsgError] = useState(true);

	const [showEstablishmentMsg, setShowEstablishmentMsg] = useState(true);
	const [showEstablishmentMsgSelected, setShowEstablishmentMsgSelected] = useState(true);
	const [showEstablishmentMsgError, setShowEstablishmentMsgError] = useState(true);

	const selectorWarehouseGroup = createSelector(
		state => state.WarehouseGroup,
		data => ({
			itemWarehouseGroupList: data.itemWarehouseGroupList,
			searchGroup: data.isLoadingList
		})
	);
	const { itemWarehouseGroupList = [] } = useSelector(selectorWarehouseGroup);


	useEffect(() => {
		if (selectedCompany) {
			setManagementKey(Date.now());
		}
	}, [selectedCompany]);


	useEffect(() => {
		if (selectedNMCapitania && Array.isArray(selectedNMCapitania.bahia)) {
			const list = selectedNMCapitania.bahia.map(b => ({
				label: b.NMBahia,
				value: b.IDBahia
			}));
			setSelectedNMBahia(list);
		} else {
			setSelectedNMBahia([]);
		}
	}, [selectedNMCapitania]);



	const selectorEstablishment = createSelector(
		state => state.Establishments,
		establishment => ({
			isAdding: establishment.isAdding,
			isAdded: establishment.isAdded,
			isUpdating: establishment.isUpdating,
			isUpdated: establishment.isUpdated,
			isLoadingList: establishment.isLoadingList,
			requireCloseModal: establishment.requireCloseModal,
		})
	);
	const {
		isAdding,
		isAdded,
		isUpdating,
		isUpdated,
		isLoadingList,
		requireCloseModal,
	} = useSelector(selectorEstablishment);


	// validation
	const validation = useFormik({
		// enableReinitialize: use this flag when initial values needs to be changed
		enableReinitialize: true,
		initialValues: {
			_id: (dataEstablishment && dataEstablishment._id) || '',
			name: (dataEstablishment && dataEstablishment.name) || '',
			email: (dataEstablishment && dataEstablishment.email) || '',
			establishment_type_id: (dataEstablishment && dataEstablishment.establishment_type_id) || '',
			property_type_id: (dataEstablishment && dataEstablishment.property_type_id) || '',
			company_id: (dataEstablishment && dataEstablishment.company_id) || '',
			management_id: (dataEstablishment && dataEstablishment.management_id) || '',
			establishment_status_id: '',
			code_siep: (dataEstablishment && dataEstablishment.code_siep) || '',
			code_retc: (dataEstablishment && dataEstablishment.code_retc) || '',
			code_sma: (dataEstablishment && dataEstablishment.code_sma) || '',
			code_sidrep: (dataEstablishment && dataEstablishment.code_sidrep) || '',
			address: (dataEstablishment && dataEstablishment.address) || '',
			latitude: (dataEstablishment && dataEstablishment.latitude !== undefined && dataEstablishment.latitude !== null) ? dataEstablishment.latitude.toString().replace('.', ',') : '',
			longitude: (dataEstablishment && dataEstablishment.longitude !== undefined && dataEstablishment.longitude !== null) ? dataEstablishment.longitude.toString().replace('.', ',') : '',
			commune_id: (dataEstablishment && dataEstablishment.commune_id) || '',
			region_id: dataEstablishment?.region_id || '',
			sanitary_vicinity_id: (dataEstablishment && dataEstablishment.sanitary_vicinity_id) || null,
			productive_area_id: (dataEstablishment && dataEstablishment.productive_area_id) || '',
			nmcapitania_id: (dataEstablishment && dataEstablishment.nmcapitania_id) || '',
			nmbahia_id: (dataEstablishment && dataEstablishment.nmbahia_id) || null,
			cost_center: (dataEstablishment && dataEstablishment.cost_center) || '',
			disabled: (dataEstablishment && dataEstablishment.disabled) || false,
			warehouse_group: (dataEstablishment && dataEstablishment.warehouse_group) || null,
			establishment_group: (dataEstablishment && dataEstablishment.establishment_group) || null,
		},

		validationSchema: Yup.object({
			name: Yup.string().required('Campo requerido'),
			email: Yup.string().email('El email no es válido').required('Campo requerido'),
			establishment_type_id: Yup.string().required('Campo requerido'),
			property_type_id: Yup.string().required('Campo requerido'),
			company_id: Yup.string().required('Campo requerido'),
			management_id: Yup.string().required('Campo requerido'),
			establishment_status_id: Yup.string().required('Campo requerido'),
			commune_id: Yup.string().required('Campo requerido'),
			region_id: Yup.string().required('Campo requerido'),
			// sanitary_vicinity_id: Yup.string().required('Campo requerido'),
			sanitary_vicinity_id: Yup.string().nullable()
				.test('sanitary_vicinity_select', 'Campo requerido', function (value) {
					if (!sanitaryVicinityCol && !value) {
						return false;
					}
					return true;
				}),

			productive_area_id: Yup.string().required('Campo requerido'),
			nmcapitania_id: Yup.string().nullable(),
			nmbahia_id: Yup.lazy((value, options) => {
				const { nmcapitania_id } = options.parent;
		
				if (nmcapitania_id) {
					return Yup.number()
						.required('Campo requerido');
				}
		
				return Yup.number().nullable();
			}),
			cost_center_id: Yup.string().nullable(),
			latitude: Yup.string()
				.required('Campo requerido')
				.matches(/^-?\d+,\d{1,6}$/, 'La latitud debe ser un número decimal con hasta 6 decimales'),
			longitude: Yup.string()
				.required('Campo requerido')
				.matches(/^-?\d+,\d{1,6}$/, 'La longitud debe ser un número decimal con hasta 6 decimales'),

		}),
		onSubmit: values => {
			const commonEstablishmentData = {
				name: values.name,
				email: values.email,
				establishment_type_id: values.establishment_type_id,
				property_type_id: values.property_type_id,
				company_id: values.company_id,
				management_id: values.management_id,
				establishment_status_id: values.establishment_status_id,
				code_siep: values.code_siep,
				code_retc: values.code_retc,
				code_sma: values.code_sma,
				code_sidrep: values.code_sidrep,
				address: values.address,
				latitude: parseFloat(values.latitude.replace(',', '.')),
				longitude: parseFloat(values.longitude.replace(',', '.')),
				commune_id: values.commune_id,
				region_id: values.region_id,
				sanitary_vicinity_id: sanitaryVicinityCol ? null : values.sanitary_vicinity_id,
				productive_area_id: values.productive_area_id,
				nmcapitania_id: values.nmcapitania_id,
				nmbahia_id: values.nmbahia_id,
				cost_center_id: values.cost_center_id,
				disabled: values.disabled,
				warehouse_group: selectedWarehouseItems,
				establishment_group: selectedEstablishmentItems,
			};

			if (isEdit) {
				const updatedEstablishment = {
					...commonEstablishmentData,
					_id: dataEstablishment._id
				};
				dispatch(updateEstablishment(updatedEstablishment));
			} else {
				dispatch(addNewEstablishment(commonEstablishmentData));
			}
		}
	});

	useEffect(() => {
		if (isOpen) {
			if (requireCloseModal) {
				dispatch(setRequireCloseModal(false));
				handleToggleModal();
			}
		}
	}, [requireCloseModal]);

	useEffect(() => {
		setDataGroupList(itemWarehouseGroupList);
	}, [itemWarehouseGroupList]);


	const handleWildcardChange = (e) => {
		const value = e.target.value;
		if (value.trim() !== '') {
			// dispatch(getWarehouseGroupList({ wildcard: value }));
		}
		else {
			setDataGroupList([])
		}
	};




	const handleAddWarehouseGroup = () => {
		if (!selectedWarehouse || !selectedWarehouseGroup) {
			setShowMsg(false)
			setShowMsgSelected(false)
			setShowMsgError(true)
			return;
		}

		setShowMsg(true)
		setShowMsgSelected(true)
		setShowMsgError(true)

		const newItem = {
			"warehouse_id": selectedWarehouse._id,
			"warehouse_name": selectedWarehouse.name,
			"warehouse_code": selectedWarehouse.code_sap,
			"warehouse_group_id": selectedWarehouseGroup._id,
			"warehouse_group_name": selectedWarehouseGroup.name,
			"warehouse_group_code": selectedWarehouseGroup.code_sap,
		};

		setSelectedWarehouseItemsState((prevItems) => {
			// Verifica si el item ya existe en la lista
			const isAlreadySelected = prevItems.some(
				(item) => item.warehouse_group_id === newItem.warehouse_group_id
			);

			if (isAlreadySelected) {
				setShowMsg(false)
				setShowMsgSelected(true)
				setShowMsgError(false)
				return prevItems; // No agrega si ya existe
			}

			const updatedList = [...prevItems, newItem];
			console.log("Lista actualizada de ítems seleccionados:", updatedList);
			return updatedList;
		});
	};

	const handleRemoveWarehouseGroupItem = (warehouseGroupId) => {
		setSelectedWarehouseItemsState((prevItems) =>
			prevItems.filter(item => item.warehouse_group_id !== warehouseGroupId)
		);
	};

	const warehouseColumns = useMemo(
		() => [
			{
				header: 'Acciones', enableSorting: false, enableColumnFilter: false, enableGlobalFilter: false, enableColumnActions: false,
				accessorKey: 'acciones',
				columnDefType: 'display',
				size: 'auto',
				Cell: ({ row }) => {
					const { warehouse_group_id } = row.original;
					return (
						<React.Fragment>
							<div className='d-flex'>
								<div className='flex-shrink-0'>
									<ul className='list-inline mb-0'>
										<li className='list-inline-item'>
											<Link
												to='#'
												className='remove-item-btn'
												onClick={() => handleRemoveWarehouseGroupItem(warehouse_group_id)}
											>
												<i className='ri-delete-bin-line align-bottom me-2 text-muted'></i>
											</Link>
										</li>
									</ul>
								</div>
							</div>
						</React.Fragment>
					);
				},
			},
			{ header: 'Código Bodega', accessorKey: 'warehouse_code' },
			{ header: 'Bodega', accessorKey: 'warehouse_name' },
			{ header: 'Código Grupo Item', accessorKey: 'warehouse_group_code' },
			{ header: 'Nombre Grupo Item', accessorKey: 'warehouse_group_name' },
		],
		[]
	);









	const handleAddEstablishmentGroup = () => {
		if (!selectedEstablishmentGroup) {
			setShowEstablishmentMsg(false)
			setShowEstablishmentMsgSelected(false)
			setShowEstablishmentMsgError(true)
			return;
		}

		setShowEstablishmentMsg(true)
		setShowEstablishmentMsgSelected(true)
		setShowEstablishmentMsgError(true)

		const newItem = {
			"establishment_id": selectedEstablishmentGroup._id,
			"establishment_name": selectedEstablishmentGroup.name,
			"establishment_type": selectedEstablishmentGroup.establishment_type.name,
		};

		setSelectedEstablishmentItemsState((prevItems) => {
			// Verifica si el item ya existe en la lista
			const isAlreadySelected = prevItems.some(
				(item) => item.establishment_id === newItem.establishment_id
			);

			if (isAlreadySelected) {
				setShowEstablishmentMsg(false)
				setShowEstablishmentMsgSelected(true)
				setShowEstablishmentMsgError(false)
				return prevItems; // No agrega si ya existe
			}

			const updatedList = [...prevItems, newItem];
			console.log("Lista actualizada de ítems seleccionados:", updatedList);
			return updatedList;
		});
	};

	const handleRemoveEstablishmentGroupItem = (establishmentGroupId) => {
		setSelectedEstablishmentItemsState((prevItems) =>
			prevItems.filter(item => item.establishment_id !== establishmentGroupId)
		);
	};

	const establishmentColumns = useMemo(
		() => [
			{
				header: 'Acciones', enableSorting: false, enableColumnFilter: false, enableGlobalFilter: false, enableColumnActions: false,
				accessorKey: 'acciones',
				columnDefType: 'display',
				size: 'auto',
				Cell: ({ row }) => {
					const { establishment_id } = row.original;
					return (
						<React.Fragment>
							<div className='d-flex'>
								<div className='flex-shrink-0'>
									<ul className='list-inline mb-0'>
										<li className='list-inline-item'>
											<Link
												to='#'
												className='remove-item-btn'
												onClick={() => handleRemoveEstablishmentGroupItem(establishment_id)}
											>
												<i className='ri-delete-bin-line align-bottom me-2 text-muted'></i>
											</Link>
										</li>
									</ul>
								</div>
							</div>
						</React.Fragment>
					);
				},
			},
			{ header: 'Establecimiento', accessorKey: 'establishment_name' },
			{ header: 'Tipo', accessorKey: 'establishment_type' },
		],
		[]
	);





	return (
		<Form
			className='tablelist-form'
			onSubmit={e => {
				e.preventDefault();
				if (Object.keys(validation.errors).length != 0) { toast.error('Por favor, revisa la información ingresada. Hemos encontrado algunos detalles que necesitan corrección antes de continuar.', { autoClose: 4000 }); }
				validation.handleSubmit();
				return false;
			}}
		>
			<ModalBody className='modal-body'>
				<TabContent activeTab={activeTab}>
					<TabPane tabId='1'>
						<Row className='g-3'>

							<Col lg={3}>
								<OInput
									name='name'
									label='Nombre de establecimiento'
									type='text'
									isRequired={true}
									validation={validation}
									classNameLabel='form-label'
									classNameInput='form-control'
								/>
							</Col>
							<Col lg={3}>
								<OSelect
									label='Centro de Costo'
									id='cost_center_id'
									name='cost_center_id'
									isRequired={true}
									handleLabelOptions={(item) => `${(item.name)} - ${(item?.company?.name ? item.company.name.toUpperCase() : 'SIN EMPRESA')}`}
									value={dataEstablishment?.cost_center_id || ''}
									onSelect={handleCostCenterSelect}
									requestApi={() => getCostCenterList({})}
									disabled={false}
									validation={validation}
								/>
							</Col>
							<Col lg={3}>
								<OInput
									name='email'
									label='Correo electrónico'
									type='email'
									isRequired={true}
									validation={validation}
									lg={3}
									classNameLabel='form-label'
									classNameInput='form-control'
								/>
							</Col>
							<Col lg={3}>
								<OSelect
									label='Tipo de Establecimiento'
									id='establishment_type_id'
									name='establishment_type_id'
									isRequired={true}
									value={validation.values.establishment_type_id || ''}
									onSelect={handleEstablishmentTypeSelect}
									requestApi={() => getEstablishmentTypeList({})}
									disabled={false}
									validation={validation}
								/>
							</Col>

							<Col lg={3}>
								<OSelect
									key='property_type_id'
									label='Tipo de Propiedad'
									id='property_type_id'
									name='property_type_id'
									isRequired={true}
									value={validation.values.property_type_id || ''}
									onChange={validation.handleChange}
									requestApi={() => getPropertyTypeList({})}
									validation={validation}
								/>
							</Col>
							<Col lg={3}>
								<OSelect
									key={'establishment_status_id'}
									label="Estado de Establecimiento"
									id="establishment_status_id"
									name="establishment_status_id"
									isRequired={true}
									value={(
										dataEstablishment?.establishment_status?._id || ''
									)}
									requestApi={() => getEstablishmentStatusList()}
									validation={validation}
								/>
							</Col>
							<Col lg={3}>
								<OSelect
									label='Empresa'
									id='company_id'
									name='company_id'
									isRequired={true}
									value={validation.values.company_id || ''}
									onSelect={handleCompanySelect}
									requestApi={() => getCompanyList({})}
									disabled={false}
									validation={validation}
								/>
							</Col>
							<Col lg={3}>
								<OSelect
									key={`${managementKey}`} // Use the key to force re-render
									label='Departamento'
									id='management_id'
									name='management_id'
									value={validation.values.management_id || ''}
									onSelect={handleManagementSelect}
									requestApi={() => getManagementList({ company_id: selectedCompany?._id })}
									disabled={!selectedCompany}
									validation={validation}
								/>
							</Col>
						</Row>
					</TabPane>
					<TabPane tabId='2'>
						<Row className='g-3'>
							<Col lg={3}>
								<OInput
									name='code_siep'
									label='Código SIEP'
									type='text'
									validation={validation}
									classNameLabel='form-label'
									classNameInput='form-control'
								/>
							</Col>
							<Col lg={3}>
								<OInput
									name='code_retc'
									label='Código RETC'
									type='text'
									validation={validation}
									classNameLabel='form-label'
									classNameInput='form-control'
								/>
							</Col>
							<Col lg={3}>
								<OInput
									name='code_sma'
									label='Código SMA'
									type='text'
									validation={validation}
									classNameLabel='form-label'
									classNameInput='form-control'
								/>
							</Col>
							<Col lg={3}>
								<OInput
									name='code_sidrep'
									label='Código SIDREP'
									type='text'
									validation={validation}
									classNameLabel='form-label'
									classNameInput='form-control'
								/>
							</Col>
						</Row>
					</TabPane>
					<TabPane tabId='3'>
						<Row className='g-3'>
							<Col lg={6}>
								<OInput
									name='address'
									label='Dirección de Establecimiento'
									type='text'
									validation={validation}
									classNameLabel='form-label'
									classNameInput='form-control'
								/>
							</Col>
							<Col lg={3}>
								<OInput
									name='latitude'
									label='Latitud'
									type='text'
									validation={validation}
									isRequired={true}
									classNameLabel='form-label'
									classNameInput='form-control'
								/>
							</Col>
							<Col lg={3}>
								<OInput
									name='longitude'
									label='Longitud'
									type='text'
									validation={validation}
									isRequired={true}
									classNameLabel='form-label'
									classNameInput='form-control'
								/>
							</Col>
							<Col lg={3}>
								<OSelect
									label="Región"
									id="region_id"
									name="region_id"
									isRequired={true}
									value={validation.values.region_id || ''}
									requestApi={() => getRegionList({})}
									disabled={false}
									validation={validation}
								/>
							</Col>
							<Col lg={3}>
								<OSelect
									key={`commune_id_${managementKey}`} // Use the key to force re-render
									label="Comuna"
									id="commune_id"
									name="commune_id"
									isRequired={true}
									value={validation.values.commune_id || ''}
									requestApi={() => getCommuneList({ region_id: validation.values.region_id })}
									disabled={!validation.values.region_id} // Deshabilitar si no hay región seleccionada
									validation={validation}
								/>
							</Col>
							<Col lg={3} hidden={sanitaryVicinityCol}>
								<OSelect
									label='Barrio Sanitario'
									id='sanitary_vicinity_id'
									name='sanitary_vicinity_id'
									isRequired={true}
									value={validation.values.sanitary_vicinity_id || ''}
									onSelect={handleSanitaryVicinitySelect}
									requestApi={() => getSanitaryVicinityList({})}
									disabled={false}
									validation={validation}
								/>
							</Col>
							<Col lg={3}>
								<OSelect
									label='Área Productiva'
									id='productive_area_id'
									name='productive_area_id'
									isRequired={true}
									value={validation.values.productive_area_id || ''}
									onSelect={handleProductiveArea}
									requestApi={() => getProductiveAreaList({})}
									disabled={false}
									validation={validation}
								/>
							</Col>
							<Col lg={3}>
								<OSelect
									label='Capitanía de Puerto'
									id='nmcapitania_id'
									name='nmcapitania_id'
									handleLabelOptions={(item) => `${item.NMCapitania}`}
									value={validation.values.nmcapitania_id || ''}
									onSelect={handleNMCapitania}
									requestApi={() => getDataSpedListNMCapitania({})}
									disabled={false}
									validation={validation}
								/>
							</Col>
							<Col lg={3}>
								<OSelect
									key={`nmbahia_id_${validation.values.nmcapitania_id}_${selectedNMBahia.length}`} // Forzar re-render cuando cambia nmcapitania_id o la lista de bahías
									label="Bahía"
									id="nmbahia_id"
									name="nmbahia_id"
									value={validation.values.nmbahia_id || ''}
									itemsSelect={selectedNMBahia}
									disabled={!validation.values.nmcapitania_id}
									validation={validation}
								/>
							</Col>
						</Row>
					</TabPane>
					<TabPane tabId='4'>
						<Row className='g-3'>
							<Col lg={6}>
								<OSelect
									label='Establecimiento Relacionado'
									id='establishment_id'
									name='establishment_id'
									onSelect={handleEstablishmentGroup}
									requestApi={() => {
										return getEstablishmentList()
											.then(options => {
												if (validation.values._id) {
													return options.filter(option => option._id != validation.values._id);
												}
												return options;
											});
									}}
									disabled={false}
									validation={validation}
								/>
							</Col>
							<Col lg={1}>
								<button type="button" className="btn btn-primary waves-effect waves-light mt-4" onClick={() => { handleAddEstablishmentGroup(); }}><i className="icon-plus"></i></button>
							</Col>
							<Col lg={12} hidden={showEstablishmentMsg}>
								<div hidden={showEstablishmentMsgSelected} className="alert alert-primary" role="alert">
									Debe selecionar un establecimiento.
								</div>
								<div hidden={showEstablishmentMsgError} className="alert alert-danger" role="alert">
									El establecimeinto seleccioando ya se encuentra asociado.
								</div>
							</Col>


							<Col lg={12}>
								<Row className="mt-3">
									<Col>
										<ODataGrid
											columns={establishmentColumns}
											data={selectedEstablishmentItems || []}
											nameFile={'establecimiento_asociados'} />
									</Col>
								</Row>
							</Col>
						</Row>
					</TabPane>
					<TabPane tabId='5'>
						<Row className='g-3'>
							<Col lg={5}>
								<OSelect
									label='Bodega de Destino'
									id='warehouse_id'
									name='warehouse_id'
									handleLabelOptions={(item) => `${item.company ? item.company.name.toUpperCase() + ' - ' : ''}${item.company ? item.code_sap : 'S/C'}: ${item.name}`}
									value={validation.values.warehouse_id || ''}
									onSelect={handleWarehouse}
									requestApi={() => getWarehouseList()}
									disabled={false}
									validation={validation}
								/>
							</Col>
							<Col lg={6}>
								<OSelect
									label='Grupo de Ítems'
									id='warehouse_group_id'
									name='warehouse_group_id'
									handleLabelOptions={(item) => `${item.code_sap ? item.code_sap : 'S/C'}: ${item.name} (${item.family})`}
									value={validation.values.warehouse_group_id || ''}
									onSelect={handleWarehouseGroup}
									requestApi={() => getWarehouseGroupList()}
									disabled={false}
									validation={validation}
								/>
							</Col>
							<Col lg={1}>
								<button type="button" className="btn btn-primary waves-effect waves-light mt-4" onClick={() => { handleAddWarehouseGroup(); }}><i className="icon-plus"></i></button>
							</Col>
							<Col lg={12} hidden={showMsg}>
								<div hidden={showMsgSelected} className="alert alert-primary" role="alert">
									Debe selecionar una bodega y un grupo de items de bodega.
								</div>
								<div hidden={showMsgError} className="alert alert-danger" role="alert">
									El grupo de item de bodega seleccioando, ya se encuentra asociado a una bodega
								</div>
							</Col>


							<Col lg={12}>
								<Row className="mt-3">
									<Col>
										<ODataGrid
											columns={warehouseColumns}
											data={selectedWarehouseItems || []}
											nameFile={'establecimiento_bodega'} />
									</Col>
								</Row>
							</Col>
						</Row>
					</TabPane>
				</TabContent>
			</ModalBody>
			<div className='modal-footer'>
				<div className='hstack gap-2 modal-footer-add-btn'>
					<Button
						type='button'
						onClick={() => {
							handleToggleModal();
						}} className='btn-danger btn-label'>
						<i className="icon-x label-icon"></i>
						Cancelar
					</Button>
					<button
						type='submit'
						className='btn btn-label btn-primary'
						id='add-btn'
						disabled={isAdding || isUpdating}
					>
						{isAdding || isUpdating ? (
							<i className="label-icon"><Spinner size='sm' /></i>
						) : <i className="ri-save-3-line label-icon"></i>}
						{isEdit ? 'Editar' : 'Crear'} Establecimiento
					</button>
				</div>
			</div>
		</Form>
	);
};

export default EstablishmentForm;
